<template>
    <div class="contacts-location">
        <div class="map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24533.364544298172!2d27.00250969510392!3d43.28368140462704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a58be39f7a795d%3A0x86487b3526ae1415!2z0JDQu9C60L7QvNC10YIg0JDQlA!5e1!3m2!1sbg!2sbg!4v1748959765271!5m2!1sbg!2sbg" class="map-iframe" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24533.364544298172!2d27.00250969510392!3d43.28368140462704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a58be39f7a795d%3A0x86487b3526ae1415!2z0JDQu9C60L7QvNC10YIg0JDQlA!5e1!3m2!1sbg!2sbg!4v1748959765271!5m2!1sbg!2sbg" class="map-iframe-mobile" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


          <!-- <GmapMap
            :center="{lat:10, lng:10}"
            :zoom="7"
            map-type-id="terrain"
            style="width: 500px; height: 300px"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center=m.position"
            />
          </GmapMap> -->
          <div class="contacts-box">
            <transition name="slide-in" mode="out-in">
              <div v-if="!showInqury" key="contacts-box-main" class="contacts-box-main">
                <h2>Find your way to Alcomet</h2>
                <img class="contacts-box-map" src="/static/img/contacts/location/bg.svg" alt="Bulgaria Map">
                <p class="contact-box-address">
                  <span class="strong">Alcomet AD</span><br>
                  Second Industrial Zone,<br>
                  9700 Shumen, Bulgaria<br>
                </p>
                <a class="contacts-box-btn" href="https://www.google.com/maps/place/43%C2%B017'00.2%22N+27%C2%B000'40.9%22E/@43.283393,27.0091763,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d43.283393!4d27.011365?hl=en-US" target="_blank">Coordinates - 43.283393, 27.011365</a>
                <!-- <a class="contacts-box-btn">Navigate to Alcomet</a> -->
                <div class="contacts-box-double-btns">
                    <a class="contacts-box-double-btn" href="mailto:office@alcomet.eu"><span  class="alcomet action-btn">P</span> office@alcomet.eu</a>
                    <a class="contacts-box-double-btn" href="tel:+35954858601" ><span class="alcomet action-btn">T</span> +359 54 858 601</a>
                </div>
                <!-- <a class="contacts-box-btn" @click="showInqury = true">Make an inquiry</a> -->
              </div>
              <div v-else key="contacts-box-inquiry" class="contacts-box-inquiry">
                <span class="alcomet close-inquiry" @click="showInqury = false">H</span>
                <span class="alcomet inquiry-top-img">Q</span>
                <h2>Connect with us</h2>
                <div class="custom-dropdown" :class="{ 'not-valid' : !isCategoryValid}">
                  <div class="custom-dropdown-header" @click="toggleDropdown()">
                    <p v-if="request.category">{{request.category}}</p>
                    <p v-else>Select Support Category*</p>
                    <span class="alcomet dropdown-arrow" :class="{ 'dropdown-arrow-active' : showDropdown}">I</span>
                  </div>
                  <div v-if="showDropdown" class="custom-dropdown-list">
                    <p @click="selectDropdownItem('General question')">General question</p>
                    <p @click="selectDropdownItem('Packaging')">Packaging</p>
                    <p @click="selectDropdownItem('Building & Construction')">Building &amp; Construction</p>
                    <p @click="selectDropdownItem('Transportation')">Transportation</p>
                    <p @click="selectDropdownItem('Industrial Design')">Industrial Design</p>
                    <p @click="selectDropdownItem('Events')">Events</p>
                    <p @click="selectDropdownItem('Support')">Support</p>
                    <p @click="selectDropdownItem('Other question')">Other question</p>
                  </div>
                </div>
                <input v-model="request.name" class="inquiry-input" :class="{ 'not-valid' : !isNameValid}" type="text" placeholder="Name*">
                <input v-model="request.phone" class="inquiry-input" :class="{ 'not-valid' : !isPhoneValid}" type="text" placeholder="Phone*">
                <input v-model="request.email" class="inquiry-input" :class="{ 'not-valid' : !isEmailValid}" type="text" placeholder="e-mail*">
                <textarea v-model="request.message" placeholder="Message*" class="inquiry-textarea" :class="{ 'not-valid' : !isMessageValid}" cols="30" rows="10"></textarea>
                <a class="contacts-box-btn" @click="sendInquiry()">
                  <transition name="sending" mode="out-in">
                    <span v-if="!isLoading && !isSent">
                      Submit request
                    </span>
                    <div v-else-if="isLoading && !isSent" class="loader">
                      <svg class="loader-svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                          <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                        </rect>
                        <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                          <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                        </rect>
                        <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                          <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                        </rect>
                      </svg>
                    </div>
                    <div v-else-if="isSent">
                      <svg class="sent-svg" aria-hidden="true" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                    </div>
                  </transition>
                </a>
              </div>
            </transition>
          </div>
        </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import "../../assets/scripts/smtp.js";
export default {
  components: {
    appShareButton: ShareButton
  },
  data() {
    return {
      showInqury: false,
      // inquiry category dropdown
      showDropdown: false,
      // waiting for callback after email is sent
      isLoading: false,
      // got the callback and everything's done
      isSent: false,
      // all input fields are by default true, because if not
      // their bottom border will be red
      isCategoryValid: true,
      isNameValid: true,
      isPhoneValid: true,
      isEmailValid: true,
      isMessageValid: true,
      request: {
        category: "",
        name: "",
        phone: "",
        email: "",
        message: ""
      }
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = this.showDropdown === false ? true : false;
    },
    selectDropdownItem(item) {
      this.request.category = item;
      this.showDropdown = false;
    },
    sendInquiry() {
      if (this.isValid()) {
        this.isLoading = true;
        Email.send(
          "office@alcomet.eu",
          [
            "george.apostolov@alcomet.eu",
            "maya.blaskova@alcomet.eu",
            "p.detchev@cdots.bg",
            "y.andreev@cdots.bg",
            "z.pernikov@cdots.bg"
          ],
          `Запитване от Alcomet.eu`,
          `
          Здравейте,<br><br>
          Имате ново запитване от Alcomet.eu:<br><br>

          Име: ${this.request.name},<br>
          Телефон: ${this.request.phone},<br>
          E-mail: ${this.request.email},<br>
          Категория: ${this.request.category},<br>
          Въпрос: ${this.request.message},<br><br>

          Това е автоматичен e-mail моля не отговаряйте.
          `,
          {
            token: "f038171e-cd38-4ecf-99bf-c59583653252",
            callback: message => {
              this.request = {
                category: "",
                name: "",
                phone: "",
                email: "",
                message: ""
              };
              this.isSent = true;
              setTimeout(() => {
                this.isLoading = false;
                this.isSent = false;
              }, 3000);
            }
          }
        );
      } else {
        // don't send anything
        setTimeout(() => {
          this.isCategoryValid = true;
          this.isNameValid = true;
          this.isPhoneValid = true;
          this.isEmailValid = true;
          this.isMessageValid = true;
        }, 2000);
      }
    },
    isValid() {
      if (this.request.category.length < 1) {
        this.isCategoryValid = false;
      }
      if (this.request.name.length < 1 || this.request.name.length > 50) {
        this.isNameValid = false;
      }
      if (this.request.phone.length < 1 || this.request.phone.length > 20) {
        this.isPhoneValid = false;
      }
      if (!this.validateEmail(this.request.email)) {
        this.isEmailValid = false;
      }
      if (
        this.request.message.length < 1 ||
        this.request.message.length > 500
      ) {
        this.isMessageValid = false;
      }
      if (
        !this.isCategoryValid ||
        !this.isNameValid ||
        !this.isPhoneValid ||
        !this.isEmailValid ||
        !this.isMessageValid
      ) {
        return false;
      }
      return true;
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
</script>

<style scoped>
.contacts-location {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  padding-top: 30px;
}
.map {
  height: 550px;
  position: relative;
  width: 80%;
}
.map > iframe {
  height: 100%;
  width: 100%;
}

.contacts-box {
  align-items: center;
  background-color: rgba(237, 242, 244, 0.98);
  border-radius: 6px;
  -webkit-box-shadow: 0px 29px 59px 0px rgba(51, 58, 69, 0.36);
  -moz-box-shadow: 0px 29px 59px 0px rgba(51, 58, 69, 0.36);
  box-shadow: 0px 29px 59px 0px rgba(51, 58, 69, 0.36);
  display: flex;
  flex-direction: column;
  height: 550px;
  justify-content: flex-start;
  left: 5%;
  overflow: hidden;
  padding: 25px;
  position: absolute;
  top: 5vh;
  width: 320px;
}
.contacts-box-main {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}
.contacts-box h2 {
  font-size: 18px;
  margin-bottom: 40px;
  width: 100%;
}
.contacts-box-map {
  width: 82%;
}
.contact-box-address {
  margin-top: -85px;
  margin-bottom: 85px;
  text-align: center;
}
.contacts-box-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin: 5px 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding: 7px;
  width: 100%;
}
.contacts-box-btn > span {
  font-size: 14px;
  font-weight: 500;
}
.contacts-box-btn:hover {
  background-color: #dde7ee;
}
.action-btn {
  align-items: center;
  border: 1px solid #c5d7e4;
  border-radius: 50%;
  display: inline-flex;
  font-size: 25px;
  justify-content: center;
  height: 50px;
  margin: 5px 10px 5px 0;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 50px;
}
.action-btn:hover {
  background-color: #c5d7e4;
}
.contacts-box-double-btns {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  width: 100%;
}
.contacts-box-double-btn {
  align-items: center;
  display: flex;
  width: 100%;
}
/* INQUIRY */
.contacts-box-inquiry {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
}
.close-inquiry {
  align-items: center;
  border-top-right-radius: 6px;
  color: #c5d7e4;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 30px;
  justify-content: center;
  position: absolute;
  right: -20px;
  top: -15px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 30px;
}
.close-inquiry:hover {
  background-color: #c5d7e4;
  color: #fff;
}
.inquiry-top-img {
  color: #05345e;
  font-size: 130px;
  left: -50px;
  opacity: 0.07;
  position: absolute;
  top: -30px;
}
/* DROPDOWN */
.custom-dropdown {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #c5d7e4;
  height: 32px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
  z-index: 1;
}
.custom-dropdown-header {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: space-between;
  padding: 0 10px;
}
.custom-dropdown-header > p {
  font-size: 14px;
  font-weight: 500;
}
.dropdown-arrow {
  font-size: 14px;
}
.dropdown-arrow-active {
  transform: rotate(180deg);
}
.custom-dropdown-list {
  background-color: #fff;
  border: 1px solid #c5d7e4;
  border-top: 0;
  position: absolute;
  top: 32px;
  width: 100%;
}
.custom-dropdown-list > p {
  cursor: pointer;
  font-size: 14px;
  padding: 8px 10px;
}
.custom-dropdown-list > p:hover {
  background-color: #c5d7e4;
}
.inquiry-input {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #c5d7e4;
  font-weight: 500;
  height: 32px;
  padding: 0 10px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
}
.inquiry-textarea {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #c5d7e4;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
  resize: none;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
}
.inquiry-input:-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-input::-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-input:-ms-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-input::-webkit-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea:-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea::-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea:-ms-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea::-webkit-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.not-valid {
  border-bottom: 1px solid red;
}
.loader {
  height: 16px;
  display: inline-block;
  text-align: center;
}
.loader-svg {
  height: 16px;
}
.sent-svg {
  height: 12px;
}
svg path,
svg rect {
  fill: #004787;
}
/* TRANSITION */
.slide-in-enter-active,
.slide-in-leave-active {
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.slide-in-enter {
  opacity: 0;
  transform: translateY(100%);
}
.slide-in-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
.sending-enter-active,
.sending-leave-active {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.sending-enter {
  opacity: 0;
  transform: translateX(100%);
}
.sending-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.map-iframe-mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .contacts-location {
    padding-bottom: 30px;
  }
  .map {
    width: calc(100% - 60px);
    margin-bottom: 30px;
  }
  .map-iframe {
    display: none;
  }
  .map-iframe-mobile {
    display: block;
  }
}
@media screen and (max-width: 600px) {
  .contacts-location {
    padding-bottom: 20px;
  }
  .map {
    height: initial;
    margin-bottom: 20px;
  }
  .map > iframe {
    height: 50vw;
  }
  .contacts-box {
    margin-top: 30px;
    position: static;
    width: 100%;
  }
  .contacts-box h2 {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/FactoryLocation.vue